module.exports = __webpack_public_path__ + "img/collection-weddingRingsCrown@2x.bd97231.jpg";